export default __webpack_public_path__ + "static/media/Andrzej.4a212b08.png";